import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { loadBets } from '../../actions'
import BetsList from './BetsList'
import { getSort } from '../../util'
import { betsColumns } from '../../settings'
import './Bets.css'

import get from 'lodash/get'


class BetsTable extends React.Component {
  _rowClassName = ({ rowData, index }) => {
    return classnames(
      'table-row', 
      `bet-${get(rowData, 'ticket.ticketStatus', '').toLowerCase()}`,
      {'late-bet': rowData.timeToEventStart > 0}
    )
  }

  render() {
    return <BetsList 
      {...this.props}
      columns={betsColumns} 
      entity='bets'
      rowClassName={this._rowClassName}
      isTableView={true} />
  }
}

export const Bets = connect(
  (state, ownProps) => ({
    playerId: ownProps.params.playerId,
    ...getSort(get(ownProps, 'location.query.ordering', '-delivery_date'))
  }), 
  { loadBets }
)(BetsTable)


// WEBPACK FOOTER //
// ./src/components/Players/Bets.js